import { Component, ChangeDetectionStrategy } from '@angular/core';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { PrizeBoxService } from 'src/app/services/client-area/prize-box.service';
import { AvatarService } from 'src/app/services/profile/avatar.service';
import { BasePageComponent } from '../../base-page/base-page.component';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { VipAvatarService } from 'src/app/services/vip-avatar.service';
import { Observable } from 'rxjs';

interface ProfileLoginInfo {
  userRole: boolean;
  levelConfig: any;
  roleList: string[];
}

@Component({
  selector: 'app-profile-button',
  templateUrl: './profile-button.component.html',
  styleUrls: ['./profile-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileButtonComponent extends BasePageComponent {

  constructor(
    public avatarService: AvatarService,
    public prizeBoxService: PrizeBoxService,
    public licenceService: LicenceService,
    private loginStatusService: LoginStatusService,
    private vipAvatarService: VipAvatarService,
  ) { super() }

  avatar$: Observable<string>;
  hasPrizes$: Observable<boolean>;
  loginInfo$: Observable<ProfileLoginInfo>;
  iconsBoxOpen: string;


  ngOnInit(): void {
    this.iconsBoxOpen = this.licenceService.getKey('icons-box-open-updated');
    
    this.avatar$ = this.avatarService.getAvatar().pipe(takeUntil(this.unsubscribe));

    this.loginInfo$ = this.loginStatusService.getLoginStatus().pipe(
      takeUntil(this.unsubscribe),
      map(resp => {
        const rawRoles = (resp.fullInfo?.roles as string[]) || [];
        const roleList = rawRoles.map(role => role.toLowerCase());
        const userRole = roleList.some(role => this.loginStatusService.vipRoles.includes(role));
        const levelConfig = this.vipAvatarService.getVipConfig(roleList, userRole);
        return { userRole, levelConfig, roleList };
      })
    );

    this.hasPrizes$ = this.prizeBoxService.getCurrentLevelLottery().pipe(
      switchMap(() => this.prizeBoxService.isActiveLottery()),
      takeUntil(this.unsubscribe)
    );
  }

}
